// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'versions';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M15.375 1.208H9c-.782 0-1.417.635-1.417 1.417v12.75c0 .782.635 1.417 1.417 1.417h6.375c.782 0 1.417-.635 1.417-1.417V2.625c0-.782-.635-1.417-1.417-1.417zM5.812 2.27c-.782 0-1.416.635-1.416 1.417v10.625c0 .783.634 1.417 1.416 1.417M2.625 3.333c-.782 0-1.417.635-1.417 1.417v8.5c0 .782.635 1.416 1.417 1.416' />
    <path d='M12.188 11.656a2.656 2.656 0 1 0 0-5.312 2.656 2.656 0 0 0 0 5.312z' />
    <path d='M13.12 9.31h-1.154V8.155' />
  </g>
);

export const viewBox = '0 0 18 18';
